import React from 'react';
import styled from 'styled-components';
import {QuoteIcon, Typography as Text, VerticalSpacer} from '../../elements';
import {AccentColorOptions} from 'epic-ue-theme';
import {Spotlight} from '../../wraps/spotlight/Spotlight.wrap';

const Styled = styled.div`
    text-align: left;
    .ue-icon-quote {
        font-size: 60px;
        /* Remove extra margin around the icon */
        margin-bottom: -17px;
        ${(p) => p.theme.breakpoints.down('md')} {
            font-size: 40px;
            margin-bottom: -12px;
        }
    }
`;
export interface OverviewGridQuoteProps {
    accentColor?: AccentColorOptions;
    quote?: string;
    author?: string;
    authorSubtitle?: string;
}

export const OverviewGridQuote = ({
    accentColor = 'sky',
    quote,
    author,
    authorSubtitle
}: OverviewGridQuoteProps): JSX.Element | null => {
    if (!quote) return null;

    return (
        <Styled>
            <Spotlight
                accentColor={accentColor}
                variant="small"
                offsetRatio={[-0.1, -1]}
                offsetRatioDown={[-0.2, -2]}>
                <QuoteIcon color={accentColor} />
            </Spotlight>
            <VerticalSpacer variant="custom" spacing={5} />
            <Text big>{quote}</Text>
            <VerticalSpacer variant="custom" spacing={3} />
            {author ? <Text variant="h4">{author}</Text> : ''}
            {authorSubtitle ? (
                <>
                    <VerticalSpacer variant="paragraph" />
                    <Text variant="p" caption>
                        {authorSubtitle}
                    </Text>
                </>
            ) : (
                ''
            )}
        </Styled>
    );
};
